export default __webpack_public_path__ + "static/media/guide01@2x.74316609.png";